// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var DisplayMode;
(function (DisplayMode) {
    DisplayMode[DisplayMode["Regular"] = 0] = "Regular";
    DisplayMode[DisplayMode["Compact"] = 1] = "Compact";
})(DisplayMode || (DisplayMode = {}));
export function getDisplayModeKey(displayMode) {
    switch (displayMode) {
        case DisplayMode.Regular:
            return 'property.displayMode.Regular';
        case DisplayMode.Compact:
            return 'property.displayMode.Compact';
        default:
            return '';
    }
}
export function getDisaplyModeHtmlAttribute(displayMode) {
    switch (displayMode) {
        case DisplayMode.Regular:
            return 'regular';
        case DisplayMode.Compact:
            return 'compact';
        default:
            return '';
    }
}
